import { BaseApi, PassVersionMode } from '../base-api';

export class InsightsApi extends BaseApi {
  protected readonly passVersionMode: PassVersionMode = PassVersionMode.None;

  fetchUnread = () => this.get('notifications/unread');
  createReview = (licenseId: number, threadId: string) => this.post(`/${licenseId}/reviews/${threadId}`);
}
